import * as React from 'react';
import type {DeviceActionType} from '../../../modules/ruleengine/types';
import {DeviceType, DEVICE_ACTION_TYPE} from '../../../modules/ruleengine/config/consts';
import TranslatedOption from '../../common/TranslatedOption';
import {Asset} from '@deviceinsight/ng-ui-api-client';
type Props = {
	deviceActionType: DeviceActionType | null | undefined;
	onActionTypeSelect: (actionType: DeviceActionType) => void;
	canEdit: boolean;
	availablePins: Array<string>;
	asset: Asset;
};

const RuleDeviceActionType = ({deviceActionType, onActionTypeSelect, canEdit, availablePins, asset}: Props) => {
	return (
		<select
			onChange={({target: {value}}) => onActionTypeSelect(value as DeviceActionType)}
			value={deviceActionType || ''}
			disabled={!canEdit}
			data-testid="device-action-type-select">
			{!deviceActionType && (
				<TranslatedOption
					trans={{
						id: `ruleengine.element.select.actiontype.empty`,
						defaultValue: `Please select...`
					}}
					value=""
				/>
			)}
			{asset.properties?.type !== DeviceType.kisIo && (
				<TranslatedOption
					trans={{
						id: `ruleengine.element.select.actiontype.setLed`,
						defaultValue: `Set LED`
					}}
					value={DEVICE_ACTION_TYPE.SET_LED}
				/>
			)}
			{availablePins.length && (
				<TranslatedOption
					trans={{
						id: `ruleengine.element.select.actiontype.setGpio`,
						defaultValue: `Set GPIO`
					}}
					value={DEVICE_ACTION_TYPE.SET_GPIO}
				/>
			)}
		</select>
	);
};

export default RuleDeviceActionType;
